import { ProgrammeList } from './ProgrammeList';
import { useWorkspace } from '../hooks/useWorkspace';
import { t } from '../../i18n';
import type { WorkspaceStore } from '../../domain/store';

/** Desktop-only second sidebar for the Programm screen — the equivalent of
 *  the mobile nav drawer's Programm group, but always visible. `AppShell`
 *  only renders this when `isDesktop && current === 'programm'`, so there's
 *  no CSS-media-query visibility toggle to maintain here. */
export function ProgrammeSidebar({
  store,
  onSelectProgramme,
  onNewProgramme,
}: {
  store: WorkspaceStore;
  onSelectProgramme: (id: string) => void;
  onNewProgramme: () => void;
}) {
  const workspace = useWorkspace(store);
  return (
    <nav
      aria-label={t('programme.select')}
      className="fixed top-[var(--header-h)] bottom-0 left-[var(--nav-w)] z-30 flex w-[var(--rail-w)] flex-col gap-0.5 overflow-y-auto border-r bg-background p-2.5"
    >
      <ProgrammeList
        programs={workspace.programs}
        activeId={workspace.activeProgramId}
        onSelect={onSelectProgramme}
        onNew={onNewProgramme}
      />
    </nav>
  );
}
